import { AppBar as MuiAppBar, Box } from '@mui/material'
import PropTypes from 'prop-types'

const classes = {}

const AppBar = ({ position = 'sticky' }) => {
    return (
        <MuiAppBar
            elevation={0}
            position={position}
            sx={classes.appBar}
        >
            <Box
                id="app-bar"
                sx={classes.appBarItems}
            ></Box>
        </MuiAppBar>
    )
}

AppBar.propTypes = {
    position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky']),
}

export default AppBar
